var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditObjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-647 -494)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 40,
    height: 40,
    transform: "translate(647 494)",
    fill: "#fff",
    opacity: 0.001
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M10.766,24.171A3.6,3.6,0,0,1,9.2,23.78L.974,19.312A1.674,1.674,0,0,1,0,17.889V5.86c0-.019,0-.039,0-.058H0V5.778a1.689,1.689,0,0,1,1.05-1.426L9.189.342A3.681,3.681,0,0,1,10.85,0h.063a3.681,3.681,0,0,1,1.66.341l8.136,4.01a1.69,1.69,0,0,1,1.042,1.36.941.941,0,0,1,.011.147V17.874a1.685,1.685,0,0,1-.98,1.441l-8.22,4.464a3.591,3.591,0,0,1-1.631.392h-.01q-.037,0-.075,0C10.819,24.175,10.793,24.174,10.766,24.171Zm1.012-2.088,8.119-4.41V7.759l-7.335,3.981a3.636,3.636,0,0,1-.784.29ZM1.865,17.665l8.05,4.381V12.012A3.7,3.7,0,0,1,9.2,11.74L1.865,7.758ZM11.672,10.1,19.5,5.845,11.747,2.013a1.848,1.848,0,0,0-.8-.148h-.124a1.874,1.874,0,0,0-.8.148L2.255,5.835,10.09,10.1a1.779,1.779,0,0,0,.782.167A1.817,1.817,0,0,0,11.672,10.1Z",
    transform: "translate(656.119 501.912)",
    fill: "#fff",
    stroke: "#39c481",
    strokeWidth: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditObjects);
export default __webpack_public_path__ + "static/media/icon-edit-objects.81953adad5a9f4a21206856129fc61f2.svg";
export { ForwardRef as ReactComponent };